import { config } from '../config'

export const fetchReachLocalize = async (variants, currency, country) => {
  const merchantPrices = encodeURIComponent(
    JSON.stringify([
      ...variants.map(v => {
        return {
          Price: parseFloat(v.price),
          Tag: v.shopifyId,
        }
      }),
      ...variants.map(v => {
        return {
          Price: parseFloat(v.compareAtPrice) || 0,
          Tag: v.shopifyId,
        }
      }),
    ])
  )

  return fetch(
    `https://checkout.rch.io/v2.18/localize?MerchantId=${config.REACH_MERCH_ID}&Country=${country}&MerchantPrices=${merchantPrices}`
  )
    .then(res => {
      return res.json()
    })
    .catch(e => {
      console.log(e)
      return e
    })
}

export const fetchCurrency = async (
  variants,
  country,
  onDataFetched,
  onFinish,
  handleDataEmpty
) => {
  return fetchReachLocalize(variants, null, country)
    .then(data => {
      if (
        !data.ConsumerPrices ||
        data.ConsumerPrices.every(element => element === null)
      ) {
        handleDataEmpty(true)
      }
      onDataFetched(data)
    })
    .catch(e => {
      console.log(e)
    })
    .finally(() => {
      onFinish(true)
    })
}
